import styled from 'styled-components';

import { NewStyleColor } from '../../../../utils/styles-constants';
import { hexToRgba } from '../../../../utils/style';

const FileName = styled('div')`
	position: relative;
	margin-bottom: 15px;
	padding-left: 40px;
	font-family: HelveticaNeue, sans-serif;
	font-size: 15px;
	line-height: 20px;
	color: ${hexToRgba(NewStyleColor.White, 75)};
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;

	> svg {
		position: absolute;
		top: 0;
		left: 10px;
		width: 20px;
		height: 20px;
		fill: currentColor;
	}
`;

const ButtonBackWrapper = styled('div')`
	margin-bottom: 15px;
`;

export {
	FileName,
	ButtonBackWrapper,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/ResourcePanel/styles.ts